import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { connect } from 'react-redux';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { REDIRECT_CONSTANTS } from 'constants/constants';
import Layout from '../layout';

const { REDIRECT_URL, HOME_ROUTE } = REDIRECT_CONSTANTS;

const Wrapper = styled.div`
  position: relative;
`;
class PrivateRoute extends PureComponent {
  static defaultProps = {
    userType: null,
  };

  static propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    isStaff: PropTypes.bool.isRequired,
    userType: PropTypes.string,
    access: PropTypes.bool.isRequired,
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  };

  render() {
    const { isStaff } = this.props;
    const {
      loggedIn,
      userType,
      access = isStaff,
      component: Component,
      location,
      ...rest
    } = this.props;

    const { pathname, search } = location || {};
    const redirectURL = localStorage.getItem(REDIRECT_URL);

    return (
      <Route
        {...rest}
        render={props => {
          if (loggedIn) {
            if (access) {
              return (
                <Layout>
                  <Wrapper>
                    <Component {...props} />
                  </Wrapper>
                </Layout>
              );
            }
            return (
              <Layout>
                <Redirect
                  to={{
                    pathname: HOME_ROUTE,
                  }}
                />
              </Layout>
            );
          }
          if (pathname && pathname !== HOME_ROUTE && redirectURL !== HOME_ROUTE) {
            localStorage.setItem(REDIRECT_URL, `${pathname}${search}`);
          }

          return (
            <Redirect
              to={{
                pathname: '/login',
              }}
            />
          );
        }}
      />
    );
  }
}

const selector = ({ auth: { loggedIn, isStaff } }) => ({
  loggedIn,
  isStaff,
});

export default withRouter(connect(selector)(PrivateRoute));
